import { useFormContext, Controller } from 'react-hook-form';
import JTextFieldBase, { JTextFieldBaseProps } from '@atoms/JTextFieldBase';

const JTextFieldForm = ({ name, ...props }: JTextFieldBaseProps) => {
  const {
    register,
    control,
    formState: { errors, touchedFields },
  } = useFormContext();

  if (!name) return <></>;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <JTextFieldBase
          {...register(name)}
          error={!!(touchedFields?.[name] && errors?.[name])}
          helperText={touchedFields?.[name] && errors?.[name]?.message}
          {...field}
          {...props}
          ref={null}
        />
      )}
    />
  );
};

export default JTextFieldForm;
